// extracted by mini-css-extract-plugin
export default {"gift":"style_gift__AKl3z","option":"style_option__KJXLH","tipsRange":"style_tipsRange__-b2Nd","oneOption":"style_oneOption__j4EYk"};